/* Polsk katalog for locale-invoice-detail-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  'inv.detail.completion': 'Realizacja',
  'inv.detail.completed': 'Zrealizowano',
  'inv.detail.notCompleted': 'Nie zrealizowano',
  'inv.detail.paymentStatus': 'Status płatności',
  'inv.detail.paid': 'Zapłacono',
  'inv.detail.remaining': 'Pozostało',
  'inv.detail.registeredPayments': 'Zarejestrowane płatności',
  'inv.detail.registerPayment': 'Zarejestruj płatność',
  'inv.detail.settlementStatus': 'Rozliczenie',
  'inv.detail.creditOffset': 'Skompensowano',
  'inv.detail.creditRefunded': 'Zwrócono',
  'inv.detail.creditOpen': 'Nie zwrócono',
  'inv.detail.offsetAgainst': 'Skompensowano z: {document}',
  'inv.detail.offsetAgainstInvoice': 'Skompensowano z fakturą',
  'inv.detail.refunded': 'Zwrócono',
  'inv.detail.toCredit': 'Należne klientowi',
  'inv.detail.registeredRefunds': 'Zarejestrowane zwroty',
  'inv.detail.registerRefund': 'Zarejestruj zwrot',
  'inv.detail.amountTitle': 'Kwota',
  'inv.detail.amountHelp': 'Kwota netto, VAT i kwota całkowita są obliczane z zapisanych pozycji faktury.',
  'inv.detail.net': 'Netto',
  'inv.detail.totalAmount': 'Kwota całkowita',
  'inv.detail.history': 'Historia',
  'inv.detail.action': 'Działanie',
  'inv.detail.loadingDoc': 'Ładowanie dokumentu...',
  'inv.detail.openedFromLink': 'Dokument otwarty z linku',
  'inv.act.open': 'Otwórz',
  'inv.act.openHelp': 'Otwórz szkic w Nowej sprzedaży, aby go edytować i wysłać.',
  'inv.act.send': 'Wyślij',
  'inv.act.sendAgain': 'Wyślij ponownie',
  'inv.act.sendCreditNote': 'Wyślij fakturę korygującą',
  'inv.act.sendHelp': 'Wyślij dokument do klienta e-mailem przez backend.',
  'inv.act.markDelivered': 'Oznacz jako dostarczone',
  'inv.act.markDeliveredHelp': 'Użyj, gdy dokument został dostarczony klientowi poza Plumme.',
  'inv.act.view.invoice': 'Zobacz fakturę',
  'inv.act.view.quote': 'Zobacz ofertę',
  'inv.act.view.orderConfirmation': 'Zobacz potwierdzenie zamówienia',
  'inv.act.view.creditNote': 'Zobacz fakturę korygującą',
  'inv.act.viewHelp': 'Podejrzyj dokument tak, jak widzi go klient.',
  'inv.act.copyLink': 'Kopiuj link',
  'inv.act.copyLinkHelp': 'Skopiuj link do udostępnienia dokumentu.',
  'inv.act.download': 'Pobierz',
  'inv.act.downloadHelp': 'Pobierz dokument jako PDF.',
  'inv.act.packingSlip': 'Utwórz list przewozowy',
  'inv.act.packingSlipHelp': 'Utwórz i pobierz list przewozowy dla towarów z tej faktury.',
  'inv.act.copy': 'Utwórz kopię',
  'inv.toast.copyOpened': 'Kopia jest otwarta — zapisz ją jako szkic lub utwórz',
  'inv.act.share': 'Udostępnij',
  'inv.act.shareHelp': 'Skopiuj link do udostępnienia, pobierz PDF lub utwórz list przewozowy.',
  'inv.share.title': 'Udostępnij dokument',
  'inv.act.convertOffer': 'Utwórz',
  'inv.act.convertOfferHelp': 'Tworzy fakturę lub potwierdzenie zamówienia jako szkic, z klientem i pozycjami z oferty.',
  'inv.convert.title': 'Utwórz z oferty',
  'inv.convert.invoice': 'Faktura',
  'inv.convert.invoiceHelp': 'Zwykły termin płatności. Księgowana przy utworzeniu.',
  'inv.convert.order': 'Potwierdzenie zamówienia',
  'inv.convert.orderHelp': 'Potwierdza umowę bez fakturowania. Można zafakturować później.',
  'inv.act.markAccepted': 'Oznacz jako zaakceptowaną',
  'inv.act.markAcceptedHelp': 'Użyj tego, gdy klient zaakceptował ofertę ustnie, na spotkaniu lub e-mailem. Akceptacja dokonana przez klienta w linku do oferty jest rejestrowana automatycznie.',
  'inv.act.undoAccepted': 'Usuń akceptację',
  'inv.act.undoAcceptedHelp': 'Cofa akceptację zarejestrowaną tutaj w aplikacji. Akceptacji dokonanej przez samego klienta nie można usunąć.',
  'inv.act.copyHelp': 'Utwórz nową fakturę o takiej samej treści jak ta.',
  'inv.act.credit': 'Wystaw korektę',
  'inv.act.creditHelp': 'Utwórz fakturę korygującą, która skompensuje tę fakturę.',
  'inv.act.delete': 'Usuń',
  'inv.act.deleteHelp': 'Usuń ten szkic. Nie można tego cofnąć.',
  'inv.err.actionFailed': 'Nie udało się wykonać działania.',
  'inv.err.openDoc': 'Nie udało się otworzyć dokumentu.',
  'inv.err.previewPacking': 'Nie udało się wyświetlić podglądu listu przewozowego.',
  'inv.err.settleNotConnected': 'Rozliczenie bez płatności nie jest połączone z backendem.',
  'inv.err.settleFailed': 'Nie udało się rozliczyć bez płatności.',
  'inv.err.needEmail': 'Najpierw wpisz e-mail odbiorcy.',
  'inv.err.emailCharset': 'Adresy e-mail nie mogą zawierać æ, ø, å ani innych znaków specjalnych.',
  'inv.err.invalidEmail': 'To nie wygląda na prawidłowy adres e-mail.',
  'inv.err.acceptNotConnected': 'Akceptacja nie jest połączona z backendem.',
  'inv.err.acceptFailed': 'Nie udało się zaktualizować akceptacji.',
  'inv.err.convertNotConnected': 'Konwersja nie jest połączona z backendem.',
  'inv.err.convertOpenFailed': 'Szkic został utworzony, ale nie udało się go otworzyć.',
  'inv.err.convertFailed': 'Nie udało się utworzyć dokumentu z oferty.',
  'inv.err.copyOpenFailed': 'Kopia została utworzona, ale nie udało się jej otworzyć.',
  'inv.err.deleteNotConnected': 'Usuwanie nie jest połączone z backendem.',
  'inv.err.deleteFailed': 'Nie udało się usunąć szkicu.',
  'inv.toast.onlyDrafts': 'Tutaj można usuwać tylko szkice',
  'inv.toast.offerAccepted': 'Oferta została oznaczona jako zaakceptowana',
  'inv.toast.offerAcceptanceRemoved': 'Akceptacja została usunięta',
  'inv.toast.invoiceDraftFromOffer': 'Faktura jest otwarta — zapisz ją jako szkic lub utwórz',
  'inv.toast.orderDraftFromOffer': 'Potwierdzenie zamówienia jest otwarte — zapisz je jako szkic lub utwórz',
  'inv.toast.draftDeleted': 'Szkic usunięty',
  'inv.pay.settleWithout': 'Rozliczono bez płatności',
  'inv.pay.saveChange': 'Zapisz zmianę',
  'inv.pay.paidDate': 'Data płatności',
  'inv.pay.datePh': 'dd.mm.rrrr',
  'inv.pay.registerPaymentTitle': 'Zarejestruj płatność',
  'inv.pay.editPaymentTitle': 'Edytuj płatność',
  'inv.pay.registerRefundTitle': 'Zarejestruj zwrot',
  'inv.pay.editRefundTitle': 'Edytuj zwrot',
  'inv.pay.paidFrom': 'Zapłacono z',
  'inv.pay.refundDate': 'Data zwrotu',
  'inv.pay.refundAmount': 'Zwrócona kwota',
  'inv.pay.remainingNote': 'Pozostało do zapłaty na fakturze: {amount}. Możesz zarejestrować płatność częściową.',
  'inv.pay.refundNote': 'Klientowi należy się {amount} z faktury korygującej. Możesz zarejestrować częściowy zwrot.',
  'inv.pay.refundHelp': 'Faktura korygująca i tak odwraca sprzedaż. Rejestruj zwrot tylko wtedy, gdy klient faktycznie otrzymuje pieniądze z powrotem.',
  'inv.pay.fee': 'Opłata bankowa i kartowa',
  'inv.pay.feeAccount': 'Konto opłat',
  'inv.pay.bankAmountIn': 'Faktyczna kwota wpływu na rachunek: {amount}',
  'inv.pay.bankAmountOut': 'Faktyczna kwota wypływu z rachunku: {amount}',
  'inv.detail.offsetCustomerCredit': 'Skompensuj należność klienta',
  'inv.detail.customerCreditOffset': 'Skompensowana należność klienta',
  'inv.detail.customerCreditAllocated': 'Skompensowano z inną fakturą',
  'inv.detail.relatedRefund': 'Zwrócono przez powiązaną fakturę korygującą',
  'inv.toast.customerCreditOffset': 'Należność klienta została skompensowana z fakturą',
  'inv.err.noCustomerCredit': 'Nie znaleziono dostępnej faktury korygującej klienta.',
  'inv.err.customerCreditOffsetFailed': 'Nie udało się skompensować należności klienta.',
  'cust.ledger.creditOffset': 'Skompensowana należność klienta',
  'inv.toast.paymentRegistered': 'Wpłata zarejestrowana',
  'inv.toast.paymentUpdated': 'Płatność zaktualizowana',
  'inv.toast.refundRegistered': 'Zwrot zarejestrowany',
  'inv.toast.refundUpdated': 'Zwrot zaktualizowany',
  'inv.err.paymentFailed': 'Nie udało się zarejestrować wpłaty.',
  'inv.err.paymentUpdateFailed': 'Nie udało się zaktualizować płatności.',
  'inv.err.refundFailed': 'Nie udało się zarejestrować zwrotu.',
  'inv.err.refundUpdateFailed': 'Nie udało się zaktualizować zwrotu.',
  'inv.del.confirm': 'Tak, usuń szkic',
  'inv.del.body': 'Czy na pewno chcesz usunąć ten szkic dla {customer}? Nie można tego cofnąć.',
  'inv.send.body': '{document} na kwotę {amount} zostanie wysłany do {customer} jako PDF e-mailem.',
  'inv.send.resendNote': ' To ponowna wysyłka dokumentu, który został już wysłany.',
  'inv.credit.continue': 'Przejdź do korekty',
  'inv.credit.intro': 'Faktura korygująca kompensuje fakturę dla {customer}. Wybierz, czy chcesz skorygować całą fakturę, czy tylko jej część.',
  'inv.credit.full': 'Pełna korekta',
  'inv.credit.partial': 'Częściowa korekta',
  'inv.credit.line': 'Pozycja',
  'inv.credit.count': 'Ilość',
  'inv.credit.credited': 'Do korekty',
  'inv.credit.total': 'Kwota faktury korygującej',
  'inv.credit.breakdown': 'Netto {net} · VAT {vat}',
  'inv.credit.partialSuffix': ' · częściowa korekta',
  'inv.delivery.rowFailed': 'Nie dotarło',
  'inv.delivery.bannerTitle': 'Dokumenty, które nie dotarły do odbiorcy: {n}',
  'inv.delivery.bannerBody': 'E-mail został odrzucony lub wrócił: {documents}. Otwórz dokument, popraw adres e-mail klienta i wyślij ponownie.',
  'inv.credit.rest': 'Skoryguj pozostałą część',
  'inv.credit.alreadyCredited': 'Już skorygowano: {amount}. Możesz skorygować tylko pozostałą część.',
  'inv.credit.closedLines': 'W pełni skorygowane pozycje (ukryte): {n}.',
  'inv.credit.lineAlready': 'skorygowano {amount}',
  'inv.credit.hasPayments': 'Faktura ma zarejestrowane płatności. Faktura korygująca kompensuje otwartą kwotę; ewentualny zwrot rejestruje się osobno.',
  'inv.credit.date': 'Data faktury korygującej',
  'inv.credit.dateHint': 'Data określa, w którym okresie księgowym i okresie VAT zostanie ujęta korekta.',
  'inv.credit.dateBeforeInvoice': 'Data noty kredytowej nie mo?e by? wcze?niejsza ni? data faktury.',
  'inv.credit.invalidDate': 'Wybierz prawidłową datę faktury korygującej.',
  'inv.credit.paidConfirmTitle': 'Faktura została opłacona',
  'inv.credit.paidConfirmBody': 'Ta faktura ma zarejestrowane wpłaty na kwotę {amount}. Faktura korygująca wycofuje sprzedaż, ale ewentualny zwrot rejestruje się osobno. Chcesz kontynuować?',
  'inv.credit.paidConfirmContinue': 'Tak, kontynuuj korektę',
  'inv.bulk.creditDateHint': 'Ta sama data jest używana dla wszystkich faktur korygujących. Data określa okres księgowy i okres VAT.',
  'inv.bulk.creditDateBeforeInvoices': 'Data nie mo?e by? wcze?niejsza ni? najp??niejsza data faktury w zaznaczeniu.',
  'inv.bulk.creditPaidConfirmBody': 'Wybrane faktury z zarejestrowanymi wpłatami: {n}. Faktury korygujące wycofują sprzedaż, ale ewentualne zwroty rejestruje się osobno. Chcesz kontynuować?',
  'inv.history.creditPartial': 'Częściowo skorygowano {amount} · faktura korygująca {document}',
  'inv.history.creditFull': 'Skorygowano {amount} · faktura korygująca {document}',
  'inv.history.creditDraft': 'Faktura korygująca {document} utworzona jako szkic · {amount}',
  'inv.history.creditNoNumber': 'bez numeru',
  'inv.toast.creditOpened': 'Faktura korygująca do {document} jest otwarta — podaj przyczynę i utwórz ją',
  'inv.toast.partialCreditOpened': 'Częściowa faktura korygująca do {document} jest otwarta — podaj przyczynę i utwórz ją',
  'inv.bulk.selectAll': 'Zaznacz wszystkie widoczne',
  'inv.bulk.selectRow': 'Zaznacz dokument. Shift+kliknięcie zaznacza zakres.',
  'inv.bulk.selectDocument': 'Zaznacz dokument',
  'inv.bulk.selectDocuments': 'Zaznacz dokumenty',
  'inv.bulk.selectedCount': 'Zaznaczono: {n}',
  'inv.bulk.shownCount': 'Widoczne na liście: {n}',
  'inv.bulk.reset': 'Wyczyść',
  'inv.bulk.deliver': 'Oznacz jako dostarczone',
  'inv.bulk.resend': 'Wyślij ponownie',
  'inv.bulk.reminder': 'Monit',
  'inv.bulk.credit': 'Skoryguj',
  'inv.bulk.issue': 'Utwórz i wyślij',
  'inv.bulk.delete': 'Usuń',
  'inv.bulk.processing': 'Przetwarzanie ...',
  'inv.bulk.document': 'Dokument',
  'inv.bulk.amount': 'Kwota',
  'inv.bulk.more': '+ {n} więcej',
  'inv.bulk.noEmail': 'brak e-maila',
  'inv.bulk.newDueDate': 'nowy termin {date}',
  'inv.bulk.reminderType': 'Typ',
  'inv.bulk.reminderNotice': 'Przypomnienie o płatności',
  'inv.bulk.reminderDunning': 'Monit',
  'inv.bulk.reminderDueDays': 'Dni do nowego terminu',
  'inv.bulk.reminderFee': 'Opłata za monit',
  'inv.bulk.reminderFeeLocked': 'Opłatę można doliczyć tylko do monitu.',
  'inv.bulk.delivery': 'Wyślij jako',
  'inv.bulk.deliveryPdf': 'Załącznik PDF',
  'inv.bulk.deliveryLink': 'Link',
  'inv.bulk.comment': 'Wiadomość do klienta',
  'inv.bulk.commentHint': 'Pojawia się w e-mailu obok podsumowania kwot. Sama faktura się nie zmienia.',
  'inv.bulk.commentPh': 'Na przykład: Widzimy, że faktura jest nieopłacona. Skontaktuj się z nami, jeśli coś jest niejasne.',
  'inv.comment.label': 'Wiadomość do klienta',
  'inv.comment.hint': 'Opcjonalny tekst dołączany do tej wysyłki.',
  'inv.comment.placeholder': 'Napisz wiadomość ...',
  'inv.comment.useSaved': 'Użyj wiadomości',
  'inv.comment.save': 'Zapisz wiadomość',
  'inv.comment.update': 'Zaktualizuj wiadomość',
  'inv.comment.saveTitle': 'Zapisz wiadomość',
  'inv.comment.updateTitle': 'Zaktualizuj wiadomość',
  'inv.comment.saveAsNew': 'Zapisz jako nową',
  'inv.comment.savedTitle': 'Zapisane wiadomości',
  'inv.comment.name': 'Nazwa wiadomości',
  'inv.comment.namePh': 'Na przykład: Uprzejme przypomnienie',
  'inv.comment.nameHint': 'Po tej nazwie znajdziesz wiadomość na liście.',
  'inv.comment.needName': 'Najpierw nadaj wiadomości nazwę',
  'inv.comment.empty': 'Nie masz jeszcze zapisanych wiadomości.',
  'inv.comment.use': 'Użyj',
  'inv.comment.saved': 'Wiadomość zapisana',
  'inv.comment.updated': 'Wiadomość zaktualizowana',
  'inv.comment.deleted': 'Wiadomość usunięta',
  'inv.comment.saveFailed': 'Nie udało się zapisać wiadomości.',
  'inv.comment.deleteFailed': 'Nie udało się usunąć wiadomości.',
  'inv.comment.notConnected': 'Wiadomości nie są połączone z backendem.',
  'inv.bulk.mode': 'Co ma się stać',
  'inv.bulk.mode.draft': 'Zapisz jako szkice',
  'inv.bulk.mode.send': 'Utwórz i wyślij',
  'inv.bulk.mode.create': 'Tylko utwórz',
  'inv.bulk.mode.hint.credit': 'Faktury korygujące trafiają do zakładki szkiców. Nic nie zostanie zaksięgowane ani wysłane, dopóki ich nie utworzysz.',
  'inv.bulk.mode.hint.creditSend': 'Faktury korygujące zostaną od razu zaksięgowane i wysłane do klientów. Tej operacji nie można cofnąć.',
  'inv.bulk.mode.hint.issueSend': 'Szkice zostaną zaksięgowane z numerem dokumentu i wysłane do klientów e-mailem.',
  'inv.bulk.mode.hint.issue': 'Szkice zostaną zaksięgowane z numerem dokumentu, ale żaden e-mail nie zostanie wysłany.',
  'inv.bulk.creditReasonOptional': 'Opcjonalne, dopóki faktura korygująca jest szkicem. Przyczyna musi zostać podana, zanim będzie można ją zaksięgować.',
  'inv.bulk.creditReasonRequired': 'Wymagane. Przyczyna widnieje na fakturze korygującej i dokumentuje, dlaczego sprzedaż została wycofana.',
  'inv.bulk.title.deliver': 'Oznacz zaznaczone dokumenty jako dostarczone',
  'inv.bulk.title.send': 'Wyślij ponownie zaznaczone dokumenty',
  'inv.bulk.title.reminder': 'Wyślij monit lub przypomnienie o płatności',
  'inv.bulk.title.credit': 'Skoryguj zaznaczone faktury',
  'inv.bulk.title.issue': 'Utwórz zaznaczone szkice',
  'inv.bulk.title.delete': 'Usuń zaznaczone szkice',
  'inv.bulk.confirm.deliver': 'Oznacz jako dostarczone',
  'inv.bulk.confirm.send': 'Wyślij ponownie',
  'inv.bulk.confirm.reminder': 'Wyślij przypomnienie',
  'inv.bulk.confirm.credit': 'Utwórz faktury korygujące',
  'inv.bulk.confirm.creditSend': 'Utwórz i wyślij faktury korygujące',
  'inv.bulk.confirm.issue': 'Utwórz dokumenty',
  'inv.bulk.confirm.issueSend': 'Utwórz i wyślij',
  'inv.bulk.confirm.delete': 'Tak, usuń szkice',
  'inv.bulk.body.deliver': 'Dokumenty, które zostaną oznaczone jako dostarczone poza Plumme: {n}. Żaden e-mail nie zostanie wysłany, a księgowanie i płatność się nie zmienią.',
  'inv.bulk.body.send': 'Dokumenty do wysłania na adres e-mail zapisany przy kliencie: {n}.',
  'inv.bulk.body.reminder': 'Przeterminowane lub nieopłacone faktury do monitowania: {n}. Oryginalna faktura nie jest ponownie księgowana.',
  'inv.bulk.body.credit': 'Faktury do skorygowania o pozostałą kwotę: {n}, jedna faktura korygująca na fakturę. Już skorygowane pozycje nie są uwzględniane ponownie.',
  'inv.bulk.body.creditSend': 'Faktury do skorygowania o pozostałą kwotę: {n}. Faktury korygujące zostaną od razu utworzone, zaksięgowane i wysłane do klienta — bez przechodzenia przez szkice.',
  'inv.bulk.body.issue': 'Szkice do utworzenia i zaksięgowania z nadaniem numeru dokumentu: {n}.',
  'inv.bulk.body.issueSend': 'Szkice do utworzenia, zaksięgowania i wysłania do klienta e-mailem: {n}.',
  'inv.bulk.body.delete': 'Szkice do usunięcia: {n}. Szkice nie są zaksięgowane, ale usunięcia nie można cofnąć.',
  'inv.bulk.skip.deliver': 'Zaznaczone wiersze, które są szkicami, zostały już dostarczone lub wysłane i zostaną pominięte: {n}.',
  'inv.bulk.skip.send': 'Zaznaczone dokumenty bez e-maila, które zostaną pominięte: {n}.',
  'inv.bulk.skip.reminder': 'Zaznaczone wiersze, których nie można tu monitować lub które nie mają e-maila: {n}.',
  'inv.bulk.skip.credit': 'Zaznaczone wiersze, których nie można tu skorygować: {n}.',
  'inv.bulk.skip.issue': 'Zaznaczone szkice bez klienta lub pozycji, których nie można tu utworzyć: {n}.',
  'inv.bulk.skip.noEmail': 'Dokumenty bez adresu e-mail: {n}. Zostaną utworzone i zaksięgowane, ale nie wysłane.',
  'inv.bulk.skip.delete': 'Zaznaczone wiersze, które nie są szkicami i nie zostaną usunięte: {n}.',
  'inv.bulk.toast.delivered': 'Dokumenty oznaczone jako dostarczone: {n}',
  'inv.bulk.toast.sent': 'Wysłane dokumenty: {n}',
  'inv.bulk.toast.reminded': 'Wysłane przypomnienia o płatności: {n}',
  'inv.bulk.toast.dunned': 'Wysłane monity: {n}',
  'inv.bulk.toast.credited': 'Faktury korygujące utworzone jako szkice: {n}',
  'inv.bulk.toast.creditedSent': 'Utworzone i wysłane faktury korygujące: {n}',
  'inv.bulk.toast.issued': 'Utworzone dokumenty: {n}',
  'inv.bulk.toast.issuedSent': 'Utworzone i wysłane dokumenty: {n}',
  'inv.bulk.toast.deleted': 'Usunięte szkice: {n}',
  'inv.bulk.toast.notSentSuffix': ', utworzone bez e-maila: {n}',
  'inv.bulk.toast.failedSuffix': ', nieudane: {n}',
  'inv.bulk.err.failed': 'Nie udało się zakończyć operacji zbiorczej.',
  'inv.bulk.err.deliverNotConnected': 'Oznaczanie jako dostarczone nie jest połączone z backendem.',
  'inv.bulk.err.sendNotConnected': 'Wysyłanie nie jest połączone z backendem.',
  'inv.bulk.err.creditNotConnected': 'Korygowanie nie jest połączone z backendem.',
  'inv.bulk.err.issueNotConnected': 'Tworzenie szkiców nie jest połączone z backendem.',
  'inv.packing.preview': 'Podgląd',
  'inv.packing.download': 'Pobierz list przewozowy',
  'inv.packing.invoiceDate': 'Data faktury',
  'inv.pay.account.1920': 'Rachunek firmowy - 1920',
  'inv.pay.account.2063': 'Prywatne - 2063',
  'inv.pay.account.1900': 'Gotówka - 1900',
  'inv.report.customer': 'Klient',
  'inv.report.product': 'Produkt',
  'inv.report.salesCount': 'Liczba sprzedaży',
  'inv.report.count': 'Ilość',
  'inv.report.exVat': 'Bez VAT',
  'inv.report.share': 'Udział w całości',
  'inv.report.noSales': 'Brak sprzedaży w okresie.',
  'inv.report.noProducts': 'W okresie nie sprzedano żadnych produktów.',
  'inv.report.openCustomer': 'Otwórz {name} w Klientach',
  'inv.report.totalCustomers': '(klienci: {n})',
  'inv.report.totalCustomer': '(klienci: {n})',
  'inv.report.totalProducts': '(produkty: {n})',
  'inv.report.totalProduct': '(produkty: {n})',
  'inv.report.total': 'Razem',
  'inv.report.tile.sales': 'Sprzedaż',
  'inv.report.tile.activeCustomers': 'Aktywni klienci',
  'inv.report.tile.newCustomers': 'Nowi klienci',
  'inv.report.tile.totalCustomers': 'Klienci łącznie',
  'inv.report.tile.customerRevenue': 'Przychody od klientów',
  'inv.report.tile.totalRevenue': 'Przychody łącznie',
  'inv.report.tile.soldProducts': 'Sprzedane produkty',
  'inv.report.tile.productTypes': 'Rodzaje produktów',
  'inv.report.tile.productRevenue': 'Przychody z produktów',
  'inv.report.unknownCustomer': 'Nieznany klient',
  'inv.report.unspecifiedSale': 'Sprzedaż nieokreślona',
  'inv.report.customerSummaryOne': 'W okresie zarejestrowano sprzedaż (liczba: {sales}) do klientów (liczba: {customers}). Sprzedaż do klientów wyniosła {amount}.',
  'inv.report.customerSummaryMany': 'W okresie zarejestrowano sprzedaż (liczba: {sales}) do klientów (liczba: {customers}). Sprzedaż do klientów wyniosła {amount}.',
  'inv.report.productSummaryOne': 'W okresie sprzedano produkty/wiersze (liczba: {count}) w rodzajach produktów (liczba: {types}) na łączną kwotę {amount}.',
  'inv.report.productSummaryMany': 'W okresie sprzedano produkty/wiersze (liczba: {count}) w rodzajach produktów (liczba: {types}) na łączną kwotę {amount}.',
  'inv.fallback.noCustomer': 'Bez klienta',
  'inv.fallback.line': 'Wiersz {n}',
  'inv.credit.fallbackDescription': 'Sprzedaż zgodnie z {document}',
  'inv.credit.dialogTitle': 'Skoryguj fakturę {number}',
  'inv.detail.validUntil': 'Ważna do',
  'inv.detail.dueDate': 'Termin płatności',
  'inv.detail.partiallyPaid': 'Częściowo opłacona',
  'inv.detail.unpaid': 'Nieopłacona',
  'inv.detail.acceptedManual': 'Zaakceptowano {date} · zarejestrowano w aplikacji',
  'inv.detail.acceptedCustomer': 'Zaakceptowano {date} · przez klienta',
  'inv.detail.orderSentAt': 'Potwierdzenie zamówienia wysłano {date}',
  'inv.detail.paymentFeeBank': 'Opłata {fee} · Bank {bank}',
  'inv.detail.deliveryFailureHelp': 'Dokument został zapisany, ale odbiorca go nie otrzymał. Popraw adres klienta i wyślij ponownie.',
  'inv.detail.timelineHelp': 'Oś czasu utworzona na podstawie zapisanego statusu dokumentu i płatności.',
  'inv.history.offerAcceptedManual': 'Oferta oznaczona jako zaakceptowana (zarejestrowano w aplikacji)',
  'inv.history.offerAcceptedCustomer': 'Oferta zaakceptowana przez klienta',
  'inv.history.orderSent': 'Wysłano potwierdzenie zamówienia',
  'inv.history.documentSentTo': '{document} wysłano do: {recipient}',
  'inv.history.deliveredExternally': 'Dostarczono poza Plumme',
  'inv.history.documentCreated': 'Utworzono dokument',
  'inv.packing.intro': 'Ustaw datę wysyłki. Domyślnie ustawiona jest dzisiejsza data.',
  'inv.packing.shippingDate': 'Data wysyłki',
  'inv.packing.contents': 'List przewozowy pokazuje opisy i ilości z wierszy faktury. Ceny, VAT i informacje o płatności nie są pokazywane.',
  'inv.packing.title': 'List przewozowy {number}',
  'inv.err.pdfPreviewNotConnected': 'Podgląd PDF nie jest połączony z backendem.',
  'inv.err.packingNotConnected': 'List przewozowy nie jest połączony z backendem.',
  'inv.err.packingDownloadFailed': 'Nie udało się pobrać listu przewozowego.',
  'inv.err.paymentNotConnected': 'Wpłaty nie są połączone z backendem.',
  'inv.err.paymentEditNotConnected': 'Edycja płatności nie jest połączona z backendem.',
  'inv.err.sendNotConnected': 'Wysyłanie nie jest połączone z backendem.',
  'inv.err.sendFailed': 'Nie udało się wysłać dokumentu.',
  'inv.err.deliverNotConnected': 'Oznaczanie jako dostarczone nie jest połączone z backendem.',
  'inv.err.deliverFailed': 'Nie udało się oznaczyć dokumentu jako dostarczonego.',
  'inv.err.linkNotConnected': 'Link do faktury nie jest połączony z backendem.',
  'inv.err.linkFailed': 'Nie udało się pobrać linku do faktury.',
  'inv.err.downloadNotConnected': 'Pobieranie PDF nie jest połączone z backendem.',
  'inv.err.downloadFailed': 'Nie udało się pobrać dokumentu.',
  'inv.err.copyNotConnected': 'Kopiowanie nie jest połączone z backendem.',
  'inv.err.copyFailed': 'Nie udało się utworzyć kopii dokumentu.',
  'inv.err.archiveNotConnected': 'Archiwizacja nie jest połączona z backendem.',
  'inv.err.archiveFailed': 'Nie udało się zaktualizować statusu archiwizacji.',
  'inv.err.creditNotConnected': 'Korygowanie nie jest połączone z backendem.',
  'inv.err.creditFailed': 'Nie udało się utworzyć faktury korygującej.',
  'inv.toast.packingDownloading': 'Trwa pobieranie listu przewozowego',
  'inv.toast.settledWithoutPayment': 'Faktura została rozliczona bez płatności',
  'inv.toast.sendingBackground': '{document} jest wysyłany w tle',
  'inv.toast.documentSent': 'Wysłano: {document}',
  'inv.toast.deliveredExternally': 'Dokument oznaczono jako dostarczony',
  'inv.toast.readyNoEmail': 'Dokument jest przygotowany, ale nie wysłano żadnego e-maila.',
  'inv.toast.linkCopied': 'Skopiowano link do {number}',
  'inv.toast.documentDownloading': 'Trwa pobieranie dokumentu',
  'inv.toast.archiveRestored': 'Przywrócono z archiwum',
  'inv.toast.archived': 'Zarchiwizowano',
  'inv.toast.creditCreated': 'Utworzono {document} dla {number}',
  'inv.act.unarchive': 'Przywróć z archiwum',
  'inv.act.archive': 'Archiwizuj',
  'inv.act.archiveHelp': 'Przenieś ofertę lub potwierdzenie zamówienia do archiwum albo przywróć je z archiwum.',
  'inv.convert.alreadyTitle': 'Oferta została już przekształcona w:',
  'inv.convert.duplicateWarning': 'Jeśli utworzysz kolejny dokument, musisz sam dopilnować, aby klient nie został dwukrotnie obciążony za tę samą pracę.',
  'inv.convert.footerHelp': 'Oba są tworzone jako szkice z klientem i wierszami z oferty i otwierane w procesie sprzedaży.',
  'inv.send.title': 'Wyślij {document} {number}',
  'inv.deliver.title': 'Oznacz jako dostarczone',
  'inv.deliver.body': 'Użyj tej opcji, gdy dokument został już dostarczony klientowi w inny sposób. Plumme nie wyśle żadnego e-maila. Księgowanie, VAT i status płatności się nie zmieniają, ale przypomnienia o niewysłanym dokumencie zostaną wstrzymane.',
  'inv.delivery.external': 'Dostarczono poza Plumme',
  'inv.more': 'Więcej',
  'inv.err.offerAlreadyConverted': 'Oferta została już przekształcona w ten typ dokumentu.',
  'sale.totalDiscount': 'Rabat łączny',
  'sale.totalDiscountHelp': 'Rozkładany proporcjonalnie na wszystkie wiersze produktów i zapisywany z identyfikowalnym podziałem.',
  'sale.det.currency': 'Waluta dokumentu',
  'sale.det.exchangeRate': 'Kurs do {currency}',
  'sale.det.exchangeRateDate': 'Data kursu',
  'sale.det.exchangeRateSource': 'Źródło kursu',
  'sale.det.exchangeRateSourcePh': 'Na przykład Norges Bank lub uzgodniony kurs',
  'sale.create.needCurrencyEvidence': 'Podaj dodatni kurs, datę kursu i źródło, zanim utworzysz fakturę.',
  'sale.preview.accountingAmount': 'Kwota księgowa: {amount} {currency} · kurs {rate}',
  'sale.preview.vatAccountingAmount': 'VAT w {currency}: {amount}',
});
